export function isSupported(): boolean {
  return (
    typeof globalThis.requestIdleCallback === 'function' &&
    typeof globalThis.Blob === 'function' &&
    typeof globalThis.URL === 'function' &&
    typeof globalThis.Worker === 'function'
  )
}
